import { inject, Injectable } from '@angular/core';
import { isEditorActive } from '@core/jss-proxy';

import { CONFIGMODULE_CONFIG } from './injection-tokens';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  readonly #appConfig = inject(CONFIGMODULE_CONFIG);

  public basePath = !isEditorActive() ? this.#appConfig.basePath : '';
  public appName = this.#appConfig.appName;
}
